import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/tr';

import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider as CustomThemeProvider, useTheme } from './contexts/ThemeContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { WorkTimeProvider } from './contexts/WorkTimeContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ReportCreate from './pages/ReportCreate';
import Chat from './pages/Chat';
import UserManagement from './pages/UserManagement';
import PageSettings from './pages/PageSettings';
import ReportSettings from './pages/ReportSettings';
import WorkTime from './pages/WorkTime';
import Logs from './pages/Logs';
import AdminSetup from './pages/AdminSetup';
import Panel from './pages/Panel';

// Tema oluşturma fonksiyonu
const createAppTheme = (mode: 'light' | 'dark') => createTheme({
  palette: {
    mode,
    primary: {
      main: mode === 'dark' ? '#90caf9' : '#1976d2',
    },
    secondary: {
      main: mode === 'dark' ? '#f48fb1' : '#dc004e',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },
});

// Ana uygulama bileşeni
const AppContent: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const { mode } = useTheme();
  const theme = createAppTheme(mode);

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>Yükleniyor...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="tr">
        <Router>
          <WorkTimeProvider>
            <Layout>
                  <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/reports/create" element={<ReportCreate />} />
                  <Route path="/chat" element={<Chat />} />
                  <Route path="/users" element={<UserManagement />} />
                  <Route path="/settings/pages" element={<PageSettings />} />
                  <Route path="/settings/css" element={<PageSettings />} />
                  <Route path="/settings/sidebar" element={<PageSettings />} />
                  <Route path="/settings/reports" element={<ReportSettings />} />
                  <Route path="/work-time" element={<WorkTime />} />
                  <Route path="/logs" element={<Logs />} />
                  <Route path="/admin-setup" element={<AdminSetup />} />
                  <Route path="/panel" element={<Panel />} />
                  {/* Diğer route'lar buraya eklenecek */}
                  </Routes>
            </Layout>
          </WorkTimeProvider>
        </Router>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

// Ana App bileşeni
        const App: React.FC = () => {
          return (
            <CustomThemeProvider>
              <SettingsProvider>
                <AuthProvider>
                  <AppContent />
                </AuthProvider>
              </SettingsProvider>
            </CustomThemeProvider>
          );
        };

export default App;
